import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'
import {SLOT_MANAGEMENT_DEPENDENT_FIELDS} from '../consts'

import {SlotFormData} from './types'

/**
 * Hook to get slot form data from form context.
 * Extracts all slot-management-dependent fields from the form state.
 *
 * @returns Form data required for building slot requests
 *
 * @example
 * ```tsx
 * const formData = useSlotFormData()
 * const request = buildSlotRequest(formData, options)
 * ```
 */
export const useSlotFormData = (): SlotFormData => {
  const {watch} = useOrderProcessFormContext()
  const [
    dateTime,
    quantity,
    plusLoadExpected,
    material,
    contract,
    spacingOrFlowRate,
    unloadingMethod,
    truckType,
    timeOnJobSite
  ] = watch(SLOT_MANAGEMENT_DEPENDENT_FIELDS)

  return {
    dateTime,
    quantity,
    plusLoadExpected,
    material,
    contract,
    spacingOrFlowRate,
    unloadingMethod,
    truckType,
    timeOnJobSite
  }
}
